import ListVacationPolicies from './views/List.vue'
import CreateEditVacationPolicy from './views/CreateEdit.vue'
import GetVacationPolicy from './views/Get.vue'

export const VacationPolicyRoutes = [
  {
    path: '/vacation-policies',
    name: 'ListVacationPolicies',
    component: ListVacationPolicies,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'vacation_policie:list'
    }
  },
  {
    path: '/vacation-policy',
    name: 'CreateVacationPolicy',
    component: CreateEditVacationPolicy,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'vacation_policie:create'
    }
  },
  {
    path: '/vacation-policy/:id',
    name: 'UpdateVacationPolicy',
    component: CreateEditVacationPolicy,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'vacation_policie:update'
    }
  },
  {
    path: '/vacation-policy/view/:id',
    name: 'GetVacationPolicy',
    component: GetVacationPolicy,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'vacation_policie:get'
    }
  }
]
